import React from 'react';
import {
  Clock3,
  Gamepad2,
  HardDrive,
  Keyboard,
  Monitor,
  Mouse,
  Palette,
  Printer,
  Shield,
  Users,
  Volume2,
  Wifi,
} from 'lucide-react';
import { makeOverrideIcon } from '../AppIcon';

type AppIconProps = {
  size?: number | string;
  className?: string;
};

export type ControlPanelItemDefinition = {
  id: string;
  name: string;
  description: string;
  appId: string;
  windowTitle: string;
  Icon: React.ComponentType<AppIconProps>;
};

export const ControlPanelDisplayIcon = makeOverrideIcon('display', Monitor);
export const ControlPanelSoundIcon = makeOverrideIcon('sounds', Volume2);
export const ControlPanelMouseIcon = makeOverrideIcon('mouse', Mouse);
export const ControlPanelKeyboardIcon = makeOverrideIcon('keyboard', Keyboard);
export const ControlPanelNetworkIcon = makeOverrideIcon('wifi', Wifi);
export const ControlPanelDateTimeIcon = makeOverrideIcon('clock', Clock3);
export const ControlPanelAppearanceIcon = makeOverrideIcon('display', Palette);
export const ControlPanelSecurityIcon = makeOverrideIcon('firewall', Shield);
export const ControlPanelSystemIcon = makeOverrideIcon('system', HardDrive);
export const ControlPanelPrinterIcon = makeOverrideIcon('printer', Printer);
export const ControlPanelUsersIcon = makeOverrideIcon('users', Users);
export const ControlPanelControllersIcon = makeOverrideIcon('controllers', Gamepad2);

export const CONTROL_PANEL_ITEMS: ControlPanelItemDefinition[] = [
  {
    id: 'display',
    name: 'Display',
    description: 'Change display settings',
    appId: 'display-properties',
    windowTitle: 'Display Properties',
    Icon: ControlPanelDisplayIcon,
  },
  {
    id: 'sound',
    name: 'Sounds',
    description: 'Change sound settings',
    appId: 'sound-settings',
    windowTitle: 'Sound Settings',
    Icon: ControlPanelSoundIcon,
  },
  {
    id: 'mouse',
    name: 'Mouse',
    description: 'Change mouse settings',
    appId: 'mouse-settings',
    windowTitle: 'Mouse Settings',
    Icon: ControlPanelMouseIcon,
  },
  {
    id: 'keyboard',
    name: 'Keyboard',
    description: 'Change keyboard settings',
    appId: 'keyboard-settings',
    windowTitle: 'Keyboard Settings',
    Icon: ControlPanelKeyboardIcon,
  },
  {
    id: 'network',
    name: 'Network',
    description: 'Network configuration',
    appId: 'network-settings',
    windowTitle: 'Network Settings',
    Icon: ControlPanelNetworkIcon,
  },
  {
    id: 'datetime',
    name: 'Date/Time',
    description: 'Set date and time',
    appId: 'datetime-settings',
    windowTitle: 'Date & Time Settings',
    Icon: ControlPanelDateTimeIcon,
  },
  {
    id: 'appearance',
    name: 'Appearance',
    description: 'Desktop themes',
    appId: 'appearance-settings',
    windowTitle: 'Appearance Settings',
    Icon: ControlPanelAppearanceIcon,
  },
  {
    id: 'security',
    name: 'Security',
    description: 'Security settings',
    appId: 'security-settings',
    windowTitle: 'Security Settings',
    Icon: ControlPanelSecurityIcon,
  },
  {
    id: 'system',
    name: 'System',
    description: 'System information',
    appId: 'system-information',
    windowTitle: 'System Information',
    Icon: ControlPanelSystemIcon,
  },
  {
    id: 'printers',
    name: 'Printers',
    description: 'Printer settings',
    appId: 'printers',
    windowTitle: 'Printer Settings',
    Icon: ControlPanelPrinterIcon,
  },
  {
    id: 'users',
    name: 'Users',
    description: 'User accounts',
    appId: 'user-settings',
    windowTitle: 'User Settings',
    Icon: ControlPanelUsersIcon,
  },
  {
    id: 'games',
    name: 'Game Controllers',
    description: 'Gaming devices',
    appId: 'game-controller-settings',
    windowTitle: 'Game Controller Settings',
    Icon: ControlPanelControllersIcon,
  },
];

export const CONTROL_PANEL_WINDOW_ICONS: Record<string, React.ComponentType<AppIconProps>> = {
  'display-properties': ControlPanelDisplayIcon,
  'sound-settings': ControlPanelSoundIcon,
  'mouse-settings': ControlPanelMouseIcon,
  'keyboard-settings': ControlPanelKeyboardIcon,
  'network-settings': ControlPanelNetworkIcon,
  'datetime-settings': ControlPanelDateTimeIcon,
  'appearance-settings': ControlPanelAppearanceIcon,
  'security-settings': ControlPanelSecurityIcon,
  'system-properties': ControlPanelSystemIcon,
  'system-information': ControlPanelSystemIcon,
  'mapleos-updates': ControlPanelSystemIcon,
  printers: ControlPanelPrinterIcon,
  'user-settings': ControlPanelUsersIcon,
  'game-controller-settings': ControlPanelControllersIcon,
};
